import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationTriangle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

const OkModal = ({ showModal, hideModal, message, header, type }) => {
    let icon;
    let color;
    let iconSize = '3x'; // Default size for the icon

    // Determine icon and color based on type
    switch (type) {
        case 'success':
            icon = faCheckCircle;
            color = 'green';
            break;
        case 'warning':
            icon = faExclamationTriangle;
            color = 'orange';
            break;
        case 'error':
            icon = faTimesCircle;
            color = 'red';
            break;
        default:
            icon = faCheckCircle; // Default to success icon
            color = 'green'; // Default to green color
            break;
    }

    return (
        <Modal show={showModal} onHide={hideModal}>
            <Modal.Header closeButton>
                <Modal.Title>{header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <FontAwesomeIcon icon={icon} size={iconSize} style={{ marginRight: '10px', color: color }} />
                    <span>{message}</span>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={hideModal}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default OkModal;
